import { render, staticRenderFns } from "./ShipNpay.vue?vue&type=template&id=694fcdbf&scoped=true&"
import script from "./ShipNpay.vue?vue&type=script&lang=js&"
export * from "./ShipNpay.vue?vue&type=script&lang=js&"
import style0 from "./ShipNpay.vue?vue&type=style&index=0&id=694fcdbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694fcdbf",
  null
  
)

export default component.exports